import type { ReactNode } from 'react';
import { Button, InlineNotification, SkeletonText } from '@carbon/react';
import { Renew } from '@carbon/icons-react';
import { ApiError } from '../api/client';

export function PageHeader({ title, lead, actions }: { title: string; lead?: ReactNode; actions?: ReactNode }) {
  return (
    <header className="page__head">
      <div>
        <h1>{title}</h1>
        {lead ? <p>{lead}</p> : null}
      </div>
      {actions ? <div className="page__actions">{actions}</div> : null}
    </header>
  );
}

export function EmptyState({ title, body, action }: { title: string; body?: ReactNode; action?: ReactNode }) {
  return (
    <div className="state" role="status">
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const e = error instanceof ApiError ? error : null;
  const forbidden = e?.status === 403;
  return (
    <div className="state" role="alert">
      <h3>{forbidden ? 'Không có quyền xem mục này' : 'Không tải được dữ liệu'}</h3>
      <p>
        {e?.message ?? String(error)}
        {e?.requestId ? <span className="muted"> (mã yêu cầu {e.requestId})</span> : null}
      </p>
      {onRetry && !forbidden ? <Button kind="tertiary" size="sm" renderIcon={Renew} onClick={onRetry}>Thử lại</Button> : null}
    </div>
  );
}

export function InlineError({ error }: { error: unknown }) {
  if (!error) return null;
  const e = error instanceof ApiError ? error : null;
  return (
    <InlineNotification kind="error" lowContrast hideCloseButton title={e?.code === 'VALIDATION' ? 'Dữ liệu chưa đúng' : 'Không thực hiện được'}
      subtitle={(e?.message ?? String(error)) + (e?.requestId ? ` (mã yêu cầu ${e.requestId})` : '')} />
  );
}

export function BlockSkeleton({ lines = 4 }: { lines?: number }) {
  return <div className="state" aria-busy="true"><SkeletonText paragraph lineCount={lines} /></div>;
}
